import(/* webpackMode: "eager", webpackExports: ["CommentForm"] */ "/vercel/path0/apps/web/src/app/consultations/[id]/CommentForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
